/*
 * amplitude.js
 * Javascript SDK for Amplitude
 *
 * This script has been modified by Spotify to include support for changing
 * the API endpoint.
 *
 * Created by Curtis Liu
 * Copyright (c) 2014 Sonalight, Inc. All rights reserved.
 */
(function(window, document) {

    var NAMESPACE = 'spAnalytics';

    var log = function(s) {
        console.log(NAMESPACE + ' ' + s);
    };

    /*
     * Checks if an object is an array
     */
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };

    /*
     * Converts a dictionary into a url safe query string
     */
    var queryString = function(p) {
        var pairs = []
        for (var key in p) {
            var value = p[key];
            if (isArray(value)) {
                for (var i = 0; i < value.length; i++) {
                    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value[i]));
                }
            } else {
                pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
            }
        }
        return pairs.join('&');
    };

    /*
     * Returns a random 128-bit string in hex (32 hex digits)
     */
    var UUID = function() {
        var s = [];
        for (var i = 0; i < 32; i++) {
            s[i] = Math.floor(Math.random() * 16).toString(16);
        }
        var uuid = s.join('');
        return uuid;
    };

    /*
     * UTF-8 encoder/decoder
     * http://www.webtoolkit.info/
     */
    var UTF8 = {
        encode: function (s) {
            s = s.replace(/\r\n/g,'\n');
            var utftext = '';

            for (var n = 0; n < s.length; n++) {
                var c = s.charCodeAt(n);

                if (c < 128) {
                    utftext += String.fromCharCode(c);
                }
                else if((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
                else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
            }
            return utftext;
        },

        decode: function (utftext) {
            var s = '';
            var i = 0;
            var c = 0, c1 = 0, c2 = 0;

            while ( i < utftext.length ) {
                c = utftext.charCodeAt(i);
                if (c < 128) {
                    s += String.fromCharCode(c);
                    i++;
                }
                else if((c > 191) && (c < 224)) {
                    c1 = utftext.charCodeAt(i+1);
                    s += String.fromCharCode(((c & 31) << 6) | (c1 & 63));
                    i += 2;
                }
                else {
                    c1 = utftext.charCodeAt(i+1);
                    c2 = utftext.charCodeAt(i+2);
                    s += String.fromCharCode(((c & 15) << 12) | ((c1 & 63) << 6) | (c2 & 63));
                    i += 3;
                }
            }
            return s;
        }
    };

    /*
     * Base64 encoder/decoder
     * http://www.webtoolkit.info/
     */
    var Base64 = {
        _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

        encode: function (input) {
            try {
                if (window.btoa && window.atob) {
                    return window.btoa(unescape(encodeURIComponent(input)));
                }
            } catch (e) {
                //log(e);
            }
            return Base64._encode(input);
        },

        _encode: function (input) {
            var output = '';
            var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            var i = 0;

            input = UTF8.encode(input);

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    Base64._keyStr.charAt(enc1) + Base64._keyStr.charAt(enc2) +
                    Base64._keyStr.charAt(enc3) + Base64._keyStr.charAt(enc4);
            }
            return output;
        },

        decode: function (input) {
            try {
                if (window.btoa && window.atob) {
                    return decodeURIComponent(escape(window.atob(input)));
                }
            } catch (e) {
                //log(e);
            }
            return Base64._decode(input);
        },

        _decode: function (input) {
            var output = '';
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = Base64._keyStr.indexOf(input.charAt(i++));
                enc2 = Base64._keyStr.indexOf(input.charAt(i++));
                enc3 = Base64._keyStr.indexOf(input.charAt(i++));
                enc4 = Base64._keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }
            output = UTF8.decode(output);
            return output;
        }
    };

    var userAgent = window.navigator.userAgent;
    var vendor = window.navigator.vendor;
    var platform = window.navigator.platform;

    /*
     * Browser/OS detection
     * @TODO this is yet another implementation of browser detection. Try to figure out standard Spotify way?
     */
    var BrowserDetect = {
        init: function() {
            this.browser = this.searchString(this.dataBrowser) || null;
            this.version = this.searchVersion(window.navigator.userAgent) ||
                this.searchVersion(window.navigator.appVersion) || null;
            this.OS = this.searchString(this.dataOS) || null;
        },
        searchString: function(data) {
            for (var i=0; i<data.length; i++) {
                var dataString = data[i].string;
                var dataProp = data[i].prop;
                this.versionSearchString = data[i].versionSearch || data[i].identity;
                if (dataString) {
                    if (dataString.indexOf(data[i].subString) != -1) {
                        return data[i].identity;
                    }
                }
                else if (dataProp) {
                    return data[i].identity;
                }
            }
        },
        searchVersion: function(dataString) {
            var index = dataString.indexOf(this.versionSearchString);
            if (index == -1) {
                return;
            }
            return parseFloat(dataString.substring(index + this.versionSearchString.length+1));
        },
        dataBrowser: [
            {
                string: userAgent,
                subString: 'Chrome',
                identity: 'Chrome'
            },
            {
                string: userAgent,
                subString: 'OmniWeb',
                versionSearch: 'OmniWeb/',
                identity: 'OmniWeb'
            },
            {
                string: vendor,
                subString: 'Apple',
                identity: 'Safari',
                versionSearch: 'Version'
            },
            {
                prop: window.opera,
                identity: 'Opera',
                versionSearch: 'Version'
            },
            {
                string: vendor,
                subString: 'iCab',
                identity: 'iCab'
            },
            {
                string: vendor,
                subString: 'KDE',
                identity: 'Konqueror'
            },
            {
                string: userAgent,
                subString: 'Firefox',
                identity: 'Firefox'
            },
            {
                string: vendor,
                subString: 'Camino',
                identity: 'Camino'
            },
            {   // for newer Netscapes (6+)
                string: userAgent,
                subString: 'Netscape',
                identity: 'Netscape'
            },
            {
                string: userAgent,
                subString: 'MSIE',
                identity: 'Explorer',
                versionSearch: 'MSIE'
            },
            {
                string: userAgent,
                subString: 'Gecko',
                identity: 'Mozilla',
                versionSearch: 'rv'
            },
            {   // for older Netscapes (4-)
                string: userAgent,
                subString: 'Mozilla',
                identity: 'Netscape',
                versionSearch: 'Mozilla'
            }
        ],
        dataOS : [
            {
                string: platform,
                subString: 'Win',
                identity: 'Windows'
            },
            {
                string: platform,
                subString: 'Mac',
                identity: 'Mac'
            },
            {
                string: userAgent,
                subString: 'iPhone',
                identity: 'iPhone/iPod'
            },
            {
                string: userAgent,
                subString: 'Android',
                identity: 'Android'
            },
            {
                string: platform,
                subString: 'Linux',
                identity: 'Linux'
            }
        ]

    };
    BrowserDetect.init();

    /*
     * Simple AJAX request object
     */
    var Request = function(url, data) {
        this.url = url;
        this.data = data || {};
    };

    Request.prototype.send = function(callback, error) {
        var isIE = window.XDomainRequest ? true : false;
        if (isIE) {
            var xdr = new window.XDomainRequest();
            xdr.open('POST', this.url, true);
            xdr.onload = function() {
                callback(xdr.responseText);
            };
            xdr.onerror = function() {
                error(xdr);
            };
            xdr.send(queryString(this.data));
        } else {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', this.url, true);
            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        callback(xhr.responseText);
                    } else {
                        error(xhr, xhr.status);
                    }
                }
            }
            xhr.onerror = function() {
                error(xhr, xhr.status);
            };
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            xhr.send(queryString(this.data));
        }
        //log('sent request to ' + this.url + ' with data ' + decodeURIComponent(queryString(this.data)));
    };

    /*
     * Cookie data
     */
    var Cookie = {
        get: function(name) {
            var nameEq = name + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEq) == 0) {
                    return c.substring(nameEq.length, c.length);
                }
            }
            return null;
        },
        set: function(name, value, days, domain) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = '; expires=' + date.toGMTString();
            } else {
                var expires = '';
            }
            var cookieString = name + '=' + value + expires + '; path=/' + (domain ? (";domain=" + domain) : "");
            document.cookie = cookieString;
        },
        remove: function(name, domain) {
            Cookie.set(name, '', -1, domain);
        }
    };

    /*
     * Amplitude API
     */
    var Amplitude = function() {};
    //Amplitude.SDK_VERSION = "1.3";
    //Amplitude.API_VERSION = 2;

    var options = {
        apiEndpoint: '', // changed by Spotify, no apiEndpoint by default
        cookieName: NAMESPACE + '_id',
        cookieExpiration: 365 * 10,
        unsentKey: NAMESPACE + '_unsent',
        saveEvents: true,
        domain: '',
        sessionTimeout: 30 * 60 * 1000
    };

    var eventId = 0;
    var unsentEvents = [];
    var sending = false;
    var lastEventTime = null;
    var sessionId = null;
    var LocalStorageKeys = {
        LAST_EVENT_TIME: NAMESPACE + '_lastEventTime',
        SESSION_ID: NAMESPACE + '_sessionId'
    };

    var nextEventId = function() {
        eventId++;
        return eventId;
    };

    /**
     * Initializes Amplitude.
     * opt_userId An identifier for this user
     * opt_config Configuration options
     *   - saveEvents (boolean) Whether to save events to local storage. Defaults to true.
     */
    Amplitude.prototype.init = function(opt_userId, opt_config) {
        try {
            this.options = options;
            if (opt_config) {
                if (opt_config.saveEvents !== undefined) {
                    options.saveEvents = !!opt_config.saveEvents;
                }
            }

            loadCookieData();

            options.deviceId = (opt_config && opt_config.deviceId !== undefined && opt_config.deviceId !== null && opt_config.deviceId) ||
                options.deviceId || UUID();
            options.userId = (opt_userId !== undefined && opt_userId !== null && opt_userId) || options.userId || null;
            // Added by Spotify: make it possible to configure the API endpoint
            options.apiEndpoint = (opt_config && opt_config.apiEndpoint !== undefined && opt_config.apiEndpoint !== null) && opt_config.apiEndpoint ||
                options.apiEndpoint;
            saveCookieData();

            //opt_userId !== undefined && opt_userId !== null && log('initialized with userId=' + opt_userId);
            eventId = 0;

            if (options.saveEvents) {
                var savedUnsentEventsString = localStorage.getItem(options.unsentKey);
                if (savedUnsentEventsString) {
                    try {
                        unsentEvents = JSON.parse(savedUnsentEventsString);
                    } catch (e) {
                        //log(e);
                    }
                }
            }
            if (unsentEvents.length > 0) {
                this.sendEvents();
            }

            lastEventTime = parseInt(localStorage.getItem(LocalStorageKeys.LAST_EVENT_TIME)) || null;
            sessionId = parseInt(localStorage.getItem(LocalStorageKeys.SESSION_ID)) || null;
            var now = new Date().getTime();
            if (!sessionId || !lastEventTime || now - lastEventTime > options.sessionTimeout) {
                sessionId = now;
                localStorage.setItem(LocalStorageKeys.SESSION_ID, sessionId);
            }
            lastEventTime = now;
            localStorage.setItem(LocalStorageKeys.LAST_EVENT_TIME, lastEventTime);
        } catch (e) {
            log(e);
        }
    };

    var loadCookieData = function() {
        var cookie = Cookie.get(options.cookieName);
        var cookieData = null;
        if (cookie) {
            try {
                cookieData = JSON.parse(Base64.decode(cookie));
                if (cookieData) {
                    if (cookieData.deviceId) {
                        options.deviceId = cookieData.deviceId;
                    }
                    if (cookieData.userId) {
                        options.userId = cookieData.userId;
                    }
                    if (cookieData.globalUserProperties) {
                        options.globalUserProperties = cookieData.globalUserProperties;
                    }
                }
            } catch (e) {
                //log(e);
            }
        }
    };

    var saveCookieData = function() {
        Cookie.set(options.cookieName, Base64.encode(JSON.stringify({
            deviceId: options.deviceId,
            userId: options.userId,
            globalUserProperties: options.globalUserProperties
        })), options.cookieExpiration, options.domain);
    };

    var saveEvents = function() {
        try {
            localStorage.setItem(options.unsentKey, JSON.stringify(unsentEvents));
        } catch (e) {
            //log(e);
        }
    };

    Amplitude.prototype.setDomain = function(domain) {
        try {
            options.domain = (domain !== undefined && domain !== null && ('' + domain)) || null;
            options.cookieName = NAMESPACE + '_id' + (options.domain || '');
            loadCookieData();
            saveCookieData();
            //log('set domain=' + domain);
        } catch (e) {
            log(e);
        }
    };

    Amplitude.prototype.setUserId = function(userId) {
        try {
            options.userId = (userId !== undefined && userId !== null && ('' + userId)) || null;
            saveCookieData();
            //log('set userId=' + userId);
        } catch (e) {
            log(e);
        }
    };

    Amplitude.prototype.setUserProperties = function(userProperties) {
        try {
            options.globalUserProperties = userProperties;
            saveCookieData();
            //log('set userProperties=' + JSON.stringify(userProperties));
        } catch (e) {
            log(e);
        }
    };

    Amplitude.prototype.setVersionName = function(versionName) {
        try {
            options.versionName = versionName;
            //log('set versionName=' + versionName);
        } catch (e) {
            log(e);
        }
    };

    Amplitude.prototype.logEvent = function(eventCategory, eventAction, eventLabel, eventContext) {
        try {
            var eventTime = new Date().getTime();
            if (!sessionId || !lastEventTime || eventTime - lastEventTime > options.sessionTimeout) {
                sessionId = eventTime;
                localStorage.setItem(LocalStorageKeys.SESSION_ID, sessionId);
            }
            lastEventTime = eventTime;
            localStorage.setItem(LocalStorageKeys.LAST_EVENT_TIME, lastEventTime);
            if(eventContext && typeof eventContext != 'string') {
                eventContext = JSON.stringify(eventContext);
            } else {
                eventContext = eventContext || "";
            }
            var event = {
                device_id: options.deviceId,
                user_id: options.userId || options.deviceId,
                timestamp: eventTime,
                event_id: nextEventId(),
                session_id: sessionId || -1,
                event_category: eventCategory,
                event_action: eventAction,
                event_label: eventLabel,
                event_context: eventContext,
                // api_properties: {
                // location: this.getLocation()
                // },
                client: BrowserDetect.browser,
                version_code: 0,
                version_name: options.versionName || null,
                build_version_sdk: 0,
                build_version_release: BrowserDetect.version,
                // phone_manufacturer: null,
                // phone_brand: null,
                phone_model: BrowserDetect.OS,
                global_properties: options.globalUserProperties || {}
                // country: null,
                // language: null,
                // phone_carrier: null
            };
            unsentEvents.push(event);
            if (options.saveEvents) {
                saveEvents();
            }
            //log('logged eventCategory=' + eventCategory + ', properties=' + JSON.stringify(eventProperties));
            this.sendEvents();
        } catch (e) {
            log(e);
        }
    };

    Amplitude.prototype.sendEvents = function() {
        if (!sending) {
            sending = true;
            // Changed by Spotify to be the true endpoint URL
            var url = options.apiEndpoint;
            var events = JSON.stringify(unsentEvents);
            var uploadTime = new Date().getTime();
            var data = {
                e: events,
                upload_time: uploadTime
            };
            var numEvents = unsentEvents.length;
            var scope = this;
            new Request(url, data).send(function(response) {
                sending = false;
                try {
                    var responseData = JSON.parse(response);
                    if (responseData && responseData['success'] == true) {
                        //log('sucessful upload');
                        if (unsentEvents.length > 0) {
                            scope.sendEvents();
                        }
                    }
                } catch (e) {
                    //log('failed upload');
                }
            }, function() {
                //error
                sending = false;
            });

            // TEMP as an experiment to see how this library performs
            // without retrys, remove local cache no matter what
            // (instead of successful upload block above)
            unsentEvents.splice(0, numEvents);
            if (options.saveEvents) {
                saveEvents();
            }
        }
    };

    Amplitude.prototype.runQueuedFunctions = function () {
        for (var i = 0; i < this._q.length; i++) {
            var fn = this[this._q[i][0]];
            if (fn && typeof fn === 'function') {
                fn.apply(this, this._q[i].slice(1));
            }
        }
        this._q = []; // clear function queue after running
    };

    Amplitude.prototype.__VERSION__ = '1.3';

    var old = window[NAMESPACE] || {};
    var instance = new Amplitude();
    instance._q = old._q || [];

    window[NAMESPACE] = instance;

})(window, document)
